// src/components/store/sections/faqs/FaqV11TicketfaqLimeZest.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV11TicketfaqLimeZest(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={11}
      archKey="ticket_faq"
      archLabel="Perforated Ticket Q&A"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
